export default function Django_Connect_To_Database() {
  return <div>Django_Connect_To_Database Component</div>;
}
